import * as React from 'react';

import type {NoOptionsMessageProps} from 'shells/select-picker-generic/select-picker-generic';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {SelectWithIcon} from '../select-picker/select-with-icon/select-with-icon';
import type {SelectWithIconOption} from '../select-picker/select-with-icon/select-with-icon';
import {Body} from '../typography/body';

type Props = {
    conditional: {
        title: string;
        placeholder?: string;
        selectedOption: string | null | undefined;
        options: SelectWithIconOption[];
        isDisabled?: boolean;
        customNoOptionsMessage?: NoOptionsMessageProps;
        onChange: (option: string) => void;
        tooltip?: string;
    };
    consequent: {
        title: string;
        placeholder?: string;
        selectedOption: string | null | undefined;
        options: SelectWithIconOption[];
        onChange: (option: string) => void;
    };
};

export function ConditionalSelectField(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <Body>{props.conditional.title}</Body>
            <div title={props.conditional.tooltip}>
                <SelectWithIcon
                    placeholder={props.conditional.placeholder}
                    options={props.conditional.options}
                    value={props.conditional.selectedOption}
                    onChange={props.conditional.onChange}
                    isDisabled={props.conditional.isDisabled}
                    customNoOptionsMessage={props.conditional.customNoOptionsMessage}
                />
            </div>
            {props.conditional.selectedOption && (
                <div className='flex gap-8 full-width align-center'>
                    <Body>{props.consequent.title}</Body>
                    <div className='full-width'>
                        <SelectWithIcon
                            placeholder={props.consequent.placeholder}
                            options={props.consequent.options}
                            value={props.consequent.selectedOption}
                            onChange={props.consequent.onChange}
                        />
                    </div>
                </div>
            )}
        </StackLegacy>
    );
}
